<template>
	<AccordionSection
		v-if="!applicationSent"
		:defaultExpanded="true"
		class="accordion-create-lead"
	>
		<template #accordionHeader>
			<h2 style="margin-left: 20px">Customer Information</h2>
		</template>

		<template #accordionBody>
			<ApplicantInfoPanel
				:store="store"
				:prefilledData="prefilledData"
				:validation="validation"
				:applicationSent="applicationSent"
				:isLoading="isLoading"
				:createLead="createLead"
			/>
		</template>
		<template #footer>
			<div class="accordion-footer-wrapper-default">
				<button
					class="hint-click button-save default-btn-footer"
					@click="handleCreatedLead"
					:disabled="validation.prefilledData.$invalid"
				>
					Next
				</button>
			</div>
		</template>
	</AccordionSection>
</template>
<script lang="ts">
	export interface IAccordionInfoApplication {
		store?: any;
		prefilledData?: any;
		validation?: any;
		applicationSent?: any;
		isLoading?: boolean;
		createLead?: any;
	}
</script>
<script setup lang="ts">
	import AccordionSection from '@core/components/AccordionSection.vue';
	import ApplicantInfoPanel from '@core/components/panel/ApplicantInfoPanel.vue';
	import { ref } from 'vue';

	const { applicationSent, createLead, isLoading, prefilledData, store, validation } = defineProps<IAccordionInfoApplication>();
	const emits = defineEmits(['update:isLoading']);

	const creatingError = ref(false);
	const creatingSuccess = ref(false);
	const language = ref('English');
	const isEntity = ref(false);

	const prefix = [
		{ value: null, text: '' },
		{ value: 'Dr.', text: 'Dr.' },
		{ value: 'Mr.', text: 'Mr.' },
		{ value: 'Mrs.', text: 'Mrs.' },
		{ value: 'Ms.', text: 'Ms.' },
		{ value: 'Mx.', text: 'Mx.' },
	];

	const suffix = [
		{ value: null, text: '' },
		{ value: 'Sr.', text: 'Sr.' },
		{ value: 'Jr.', text: 'Jr.' },
		{ value: 'II', text: 'II' },
		{ value: 'III', text: 'III' },
		{ value: 'IV', text: 'IV' },
		{ value: 'V', text: 'V' },
	];

	const languages = [
		{ label: 'English', value: 'English' },
		{ label: 'Spanish', value: 'Spanish' },
	];

	async function handleCreatedLead() {
		try {
			emits('update:isLoading', true);
			await createLead();
		} catch (err) {
			console.error(err);
		} finally {
			emits('update:isLoading', true);
		}
	}
</script>

<style>
	.lead-creation-container .second-line {
		margin-top: 10px;
	}

	.lead-creation-container .panel-body {
		display: flex;
	}

	.lead-creation-container input {
		text-transform: uppercase;
	}

	.lead-creation-container.lead-created {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-top: 20px;
		background-color: rgba(0, 0, 0, 0.05);
		padding: 40px;
		box-sizing: border-box;
		border-radius: 10px;
		max-width: 800px;
		align-self: center;
	}

	.accordion-create-lead .next-step-wrapper > button {
		max-width: 150px;
		margin-top: 50px;
	}
</style>
